import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo/seo"
import styled from "styled-components"
import MenuBody from "../pagesParts/menu/MenuBody"
import PageHeader from "../components/pageHeader/PageHeader"

const StyledMainWrapper = styled.main`
  margin-top: 120px;
`

export default function OurMenuPage() {
  return (
    <Layout>
      <SEO
        title="Our Menu"
        description="Explore the Origin Restaurant menu — chaofan, steak sandwiches, hotdogs, fries, and ice-cold drinks. Prices in ETB."
      />
      <StyledMainWrapper>
        <PageHeader
          heading="Our Menu"
          subheading="Big flavor, fast service — chaofan, juicy steak sandwiches, classic hotdogs, crispy fries, and ice-cold drinks."
        />
        <MenuBody />
      </StyledMainWrapper>
    </Layout>
  )
}
